import Cookies from "js-cookie"

const apiClient = async (endpoint, method = "GET", body = null) => {
  let token = Cookies.get("token")

  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )
    //console.log("->  response:", response)

    if (!response.ok) {
      console.log("->  response.status:", response.status)
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`

      if (response.status === 403 || response.status === 401) {
        Cookies.remove("token")
        window.location.href = "/"
      }

      throw new Error(errorMessage)
    }

    return await response.json()
  } catch (error) {
    // const message = error.message || "An unexpected error occurred."
    // toast.error(message, {
    //   duration: 5000,
    //   position: "bottom-right",
    // })
    console.error("API call failed:", error)

    throw error // rethrow if you want further handling upstream
  }
}

export const get = (endpoint) => apiClient(endpoint, "GET")
export const post = (endpoint, body) => apiClient(endpoint, "POST", body)
export const put = (endpoint, body) => apiClient(endpoint, "PUT", body)
